import { FC, useEffect, useState } from 'react';

import { AnchorLinkItemProps } from 'antd/es/anchor/Anchor';

import { Anchor, ColSize, ErrorResults, RowSize, SectionsSkeleton } from '../../../../../shared/components';
import { _renderSection } from '../../utils/renderSections';

import { AseguradoPoliza, InsurancePolicy } from '../../../../../shared/interfaces';

import './index.css';

interface InsuranceTabProps {
  insurancePolicyDetail?: InsurancePolicy;
  insuredsByPolicy?: AseguradoPoliza;
  showError?: boolean;
}

const MOCK_SECTIONS: Array<AnchorLinkItemProps> = [
  {
    key: 'datos-personales',
    href: '#datos-personales',
    title: 'Datos personales',
  },
  {
    key: 'direccion',
    href: '#direccion',
    title: 'Dirección',
  },
  {
    key: 'canales-de-comunicación',
    href: '#canales-de-comunicacion',
    title: 'Canales de comunicación',
  },
  {
    key: 'correo-electronico',
    href: '#correo-electronico',
    title: 'Correo electrónico',
  },
];

export const InsuranceTab: FC<InsuranceTabProps> = ({
  insurancePolicyDetail,
  insuredsByPolicy,
  showError = false,
}) => {
  const [insured, setInsured] = useState<any>();

  const setInformation = (information: any) => {
    let data = information;

    if (
      insurancePolicyDetail?.nombreAsegurado &&
      insurancePolicyDetail?.nombreAsegurado !== ''
    ) {
      const name: any = {
        label: 'Nombre',
        value: insurancePolicyDetail.nombreAsegurado,
      };
      data.person.unshift(name);
    }

    setInsured(data);
  };

  useEffect(() => {
    if( insuredsByPolicy ) {
      setInformation( insuredsByPolicy );
    }
    /* eslint-disable-next-line */
  }, [ insuredsByPolicy ])

  return (
    <div className='insurance-tab-container'>
      {
        showError
        ? <ErrorResults title='Hubo un error al intentar cargar los asegurados de la póliza' />
        : insured 
          ? (
              <RowSize rowProps={{gutter:[0 , 0]}} >
                <ColSize size={85} colProps={{ xs:{span: 21}, sm:{span: 21}}}>
                  {_renderSection(
                    'Datos personales',
                    'datos-personales',
                    insured?.person
                  )}
                  {_renderSection('Dirección', 'direccion', insured?.address)}
                  {_renderSection(
                    'Canales de comunicación',
                    'canales-de-comunicacion',
                    insured?.communication
                  )}
                  {_renderSection(
                    'Correo electrónico',
                    'correo-electronico',
                    insured?.email
                  )}
                </ColSize>

                <ColSize size={9} colProps={{id:"insurance-tab-container-anchor", xs:{span: 3}, sm:{span: 3}}} >
                  <Anchor  
                    containerId='insurance-tab-container-anchor'
                    items={MOCK_SECTIONS} 
                  />
                </ColSize>
              </RowSize>
            ) 
          : (
            <SectionsSkeleton />
          )
      }
    </div>
  );
};
